import { Modal } from '../../components/baseComponents/Modal/Modal';
import React, { useContext, useRef, useEffect, useState } from 'react';
import { captchaPuzzleContext, pathContext, myAccountContext } from '../../contexts/contexts';
import { useApiClient } from '../../hooks/useApiClient';

const CaptchaPuzzleModal = () => {
  const { captchaPuzzle, setCaptchaPuzzle } = useContext(captchaPuzzleContext);
  const captchaPuzzleDiv = useRef<HTMLDivElement>(null);
  const containerElements: Array<HTMLDivElement> = [];
  const { setUrl } = useContext(pathContext);
  const { setUser } = useContext(myAccountContext);
  const apiClient = useApiClient();
  const [captchaApiKey, setCaptchaApiKey] = useState<string>('');

  const visible = captchaPuzzle.showModal;

  const handleCaptchaPuzzleSuccess = () => {
    apiClient.post('sp_operations/captcha_passed').then((response) => {
      setCaptchaPuzzle({ showModal: false });
      setUser(response.data);
      setUrl('/dashboard');
    });
  };

  useEffect(() => {
    if (process.env.REACT_APP_CAPTCHA_API_KEY_NONPROD) {
      setCaptchaApiKey(process.env.REACT_APP_CAPTCHA_API_KEY_NONPROD);
    }

    if (visible && captchaApiKey) {
      AwsWafCaptcha.renderCaptcha(captchaPuzzleDiv.current, {
        apiKey: captchaApiKey,
        onSuccess: (token) => {
          handleCaptchaPuzzleSuccess();
        },
        onError: (renderCaptchaError) => {
          captchaPuzzle.reject!({ response: { data: { renderCaptchaError } } });
        },
      });
    }
  }, [visible]);

  return (
    <Modal
      visible={visible}
      info={false}
      hideCloseButton={true}
      hideCancelButton={true}
      hideOkButton={true}
      containerElements={containerElements}
    >
      <div ref={captchaPuzzleDiv}></div>
    </Modal>
  );
};

export default CaptchaPuzzleModal;
